var styles = {"container":"styles_container__2jt2M flex flex-column items-center justify-center","message":"styles_message__ZGrNO","name":"styles_name__2sMIx","category":"styles_category__2UF4Z"};

export default styles;
//# sourceMappingURL=styles.css.js.map
